;(function () {
  var TRYON_FLAG_KEY = 'dressx_try_on_completed'
  var EMAIL_FLAG_KEY = 'dressx_email_submitted_pending'
  var LOGIN_FLAG_KEY = 'dressx_login_pending'

  function amp() {
    return window.amplitude && typeof window.amplitude.track === 'function'
      ? window.amplitude
      : null
  }

  function track(name, props) {
    var a = amp()
    if (a) a.track(name, props)
  }

  function currentTemplate() {
    var body = document.body
    if (body) {
      var cls = String(body.className || '')
      var m =
        cls.match(/(?:^|\s)main--([a-z0-9_-]+)/i) ||
        cls.match(/(?:^|\s)template-([a-z0-9_-]+)/i)
      if (m) return m[1].toLowerCase()
      var attr = body.getAttribute && body.getAttribute('data-template')
      if (attr) return String(attr).toLowerCase()
    }
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta
      var type = meta && meta.page && meta.page.pageType
      if (type) return String(type).toLowerCase()
    } catch (e) {}
    return ''
  }

  function isSignedIn() {
    if (typeof window.__DRESSX_SIGNED_IN === 'boolean')
      return window.__DRESSX_SIGNED_IN
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta
    var customerId = meta && meta.page && meta.page.customerId
    if (customerId) return true
    return !!document.querySelector('a[href*="/account/logout"]')
  }

  function hasCompletedTryOn() {
    try {
      return sessionStorage.getItem(TRYON_FLAG_KEY) === '1'
    } catch (e) {
      return false
    }
  }

  // Widget sets window.__DRESSX_TRYON_ATC_UNTIL just before /cart/add.
  // Consume on the first added_to_cart so a later PDP add is false.
  function consumeTryOnProvided() {
    var until = 0
    try {
      until = Number(window.__DRESSX_TRYON_ATC_UNTIL) || 0
    } catch (e) {}
    try {
      window.__DRESSX_TRYON_ATC_UNTIL = 0
    } catch (e) {}
    return until > Date.now()
  }

  function params() {
    return (
      (typeof window.__DRESSX_TRYON_PARAMS === 'object' &&
        window.__DRESSX_TRYON_PARAMS) ||
      {}
    )
  }

  function getCurrency(fallback) {
    if (fallback) return String(fallback)
    try {
      if (
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
      ) {
        return String(window.Shopify.currency.active)
      }
    } catch (e) {}
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta
      if (meta && meta.currency) return String(meta.currency)
    } catch (e) {}
    return ''
  }

  function shopifyMeta() {
    try {
      return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || null
    } catch (e) {
      return null
    }
  }
  function metaProduct() {
    var m = shopifyMeta()
    return (m && m.product) || null
  }
  function currentVariantId() {
    try {
      var input = document.querySelector(
        'form[action*="/cart/add"] [name="id"]'
      )
      if (input && input.value) return String(input.value)
    } catch (e) {}
    try {
      var fromUrl = new URLSearchParams(window.location.search).get('variant')
      if (fromUrl) return String(fromUrl)
    } catch (e) {}
    var m = shopifyMeta()
    if (m && m.selectedVariantId) return String(m.selectedVariantId)
    return ''
  }
  function metaVariant(variantId) {
    var prod = metaProduct()
    if (!prod || !Array.isArray(prod.variants)) return null
    var id = String(variantId || currentVariantId() || '')
    for (var i = 0; i < prod.variants.length; i++) {
      if (String(prod.variants[i].id) === id) return prod.variants[i]
    }
    return prod.variants[0] || null
  }

  function money(cents) {
    if (cents == null || cents === '') return null
    var n = Number(cents)
    if (isNaN(n)) return null
    return n / 100
  }

  // Shopify Ajax /cart/add.js and /cart.js line items include these cent fields.
  // Theme addItemToCart often returns { items, sections } where items[0] is a
  // stub with price already in dollars (625, not 62500).
  function isAjaxLineItem(item) {
    return !!(
      item &&
      (item.final_line_price != null ||
        item.line_price != null ||
        item.original_line_price != null)
    )
  }

  function pickCartAddItem(payload) {
    if (!payload) return null
    var nested =
      Array.isArray(payload.items) && payload.items.length
        ? payload.items[0]
        : null
    if (isAjaxLineItem(nested)) return nested
    if (isAjaxLineItem(payload)) return payload
    if (nested) return nested
    if (payload.id != null) return payload
    return null
  }

  // Prefer post-promotion fields so added_to_cart matches the PDP sale price.
  function lineItemPriceRaw(item) {
    if (!item) return null
    if (item.final_price != null && item.final_price !== '')
      return item.final_price
    if (item.discounted_price != null && item.discounted_price !== '')
      return item.discounted_price
    if (item.price != null && item.price !== '') return item.price
    return null
  }

  function unitPriceDollars(item) {
    var raw = lineItemPriceRaw(item)
    if (raw != null && raw !== '') {
      if (isAjaxLineItem(item)) return money(raw)
      var n = Number(raw)
      if (!isNaN(n)) return n
    }
    var p = params()
    if (p.price != null && p.price !== '') {
      var fallback = Number(p.price)
      if (!isNaN(fallback)) return fallback
    }
    return null
  }

  function productProps(extra) {
    var p = params()
    var prod = metaProduct()
    var v = metaVariant()
    var out = {}
    var id = p.id != null ? p.id : prod && prod.id
    if (id != null) out.id = id
    var sku = p.sku || (v && v.sku)
    if (sku) out.sku = sku
    var price = p.price != null ? p.price : money(v && v.price)
    if (price != null) {
      out.price = price
      var curr = getCurrency(p.currency)
      if (curr) out.currency = curr
    }
    var cat = p.product_category || (prod && prod.type)
    if (cat) out.product_category = cat
    var brand = p.product_brand || (prod && prod.vendor)
    if (brand) out.product_brand = brand
    if (Array.isArray(p.product_collections) && p.product_collections.length) {
      out.product_collections = p.product_collections
    }
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) out[k] = extra[k]
      }
    }
    return out
  }

  var template = currentTemplate()
  var lastCheckoutLine = null
  var nativeFetch = typeof window.fetch === 'function' ? window.fetch : null

  function rememberCheckoutLine(item, currency) {
    if (!item) return
    lastCheckoutLine = {
      id: item.id,
      sku: item.sku,
      price: unitPriceDollars(item),
      product_type: item.product_type,
      vendor: item.vendor,
      currency: currency || item.currency,
    }
  }

  function rememberCart(cart) {
    if (!cart) return
    if (Array.isArray(cart.items) && cart.items.length) {
      rememberCheckoutLine(cart.items[0], cart.currency)
      return
    }
    if (cart.id) rememberCheckoutLine(cart, cart.currency)
  }

  function checkoutStartedProps() {
    var props = { try_on_completed: hasCompletedTryOn() }
    var item = lastCheckoutLine
    if (!item) return props
    if (item.id != null) props.id = item.id
    if (item.sku) props.sku = item.sku
    var price = item.price
    if (price != null) {
      props.price = price
      var curr = getCurrency(item.currency)
      if (curr) props.currency = curr
    }
    if (item.product_type) props.product_category = item.product_type
    if (item.vendor) props.product_brand = item.vendor
    return props
  }

  function prefetchCartSnapshot() {
    if (!nativeFetch) return
    try {
      var root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        '/'
      nativeFetch(root.replace(/\/?$/, '/') + 'cart.js')
        .then(function (r) {
          return r.json()
        })
        .then(function (cart) {
          if (cart) rememberCart(cart)
        })
        .catch(function () {})
    } catch (e) {}
  }

  function fireCartViewed() {
    prefetchCartSnapshot()
    track('cart_viewed', {
      signin: isSignedIn(),
      try_on_completed: hasCompletedTryOn(),
    })
  }

  function firePageLoadEvents() {
    if (window.__DRESSX_PAGE_LOAD_EVENTS_SENT) return
    window.__DRESSX_PAGE_LOAD_EVENTS_SENT = true

    track('page_view', {
      page_name: template || 'page',
      signin: isSignedIn(),
    })

    if (template.indexOf('product') === 0) {
      var source = 'direct'
      try {
        var ref = typeof document.referrer === 'string' ? document.referrer : ''
        if (ref) {
          var u = new URL(ref)
          if (u.origin === window.location.origin) {
            var path = (u.pathname || '').toLowerCase()
            if (path.indexOf('/search') !== -1) source = 'search'
            else if (path.indexOf('/cart') !== -1) source = 'cart'
            else if (path.indexOf('/collections/') !== -1) source = 'collection'
            else if (path.indexOf('wishlist') !== -1) source = 'wishlist'
            else if (path.indexOf('/account') !== -1) source = 'account'
            else if (path === '/' || path === '') source = 'home'
            else source = 'other'
          } else source = 'external'
        }
      } catch (e) {}

      track(
        'product_viewed',
        productProps({
          signin: isSignedIn(),
          try_on_completed: hasCompletedTryOn(),
          source: source,
        })
      )
    }

    if (template === 'cart') {
      fireCartViewed()
    }

    try {
      if (sessionStorage.getItem(LOGIN_FLAG_KEY) === '1' && isSignedIn()) {
        sessionStorage.removeItem(LOGIN_FLAG_KEY)
        track('login', { status: 'login successful' })
      }
    } catch (e) {}

    try {
      if (sessionStorage.getItem(EMAIL_FLAG_KEY) === '1') {
        sessionStorage.removeItem(EMAIL_FLAG_KEY)
        track('email_submitted', { description: 'user submitted email' })
      }
    } catch (e) {}
  }

  if (template !== 'cart') {
    var lastCartOpenAt = 0
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target
        if (!t || !t.closest) return
        var opener =
          t.closest('#cart-icon-bubble') ||
          t.closest('[aria-controls^="cart-drawer"]') ||
          t.closest('[js-cart-drawer-open]')
        if (!opener) return
        var now = Date.now()
        if (now - lastCartOpenAt < 600) return
        lastCartOpenAt = now
        fireCartViewed()
      },
      true
    )
  }

  function emitAddedToCart(item, currency) {
    if (!item) return
    var props = {
      signin: isSignedIn(),
      try_on_completed: hasCompletedTryOn(),
      try_on_provided: consumeTryOnProvided(),
    }
    if (item.id != null) props.id = item.id
    if (item.sku) props.sku = item.sku
    var price = unitPriceDollars(item)
    if (price != null) {
      props.price = price
      var curr = getCurrency(currency || item.currency)
      if (curr) props.currency = curr
    }
    if (item.product_type) props.product_category = item.product_type
    if (item.vendor) props.product_brand = item.vendor
    var p = params()
    if (Array.isArray(p.product_collections) && p.product_collections.length) {
      props.product_collections = p.product_collections
    }
    rememberCheckoutLine(item, currency || item.currency)
    track('added_to_cart', props)
  }

  function trackCartAdd(payload) {
    var item = pickCartAddItem(payload)
    if (!item) return
    var currency =
      (payload && payload.cart && payload.cart.currency) || item.currency
    emitAddedToCart(item, currency)
  }

  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = ''
      try {
        url = typeof input === 'string' ? input : (input && input.url) || ''
      } catch (e) {}
      var isAdd = url.indexOf('/cart/add') !== -1
      var isCartJs = url.indexOf('cart.js') !== -1
      var call = nativeFetch.apply(this, arguments)
      if (!isAdd && !isCartJs) return call
      return call.then(function (res) {
        try {
          res
            .clone()
            .json()
            .then(function (body) {
              if (isAdd) trackCartAdd(body)
              else rememberCart(body)
            })
            .catch(function () {})
        } catch (e) {}
        return res
      })
    }
  }

  if (amp()) firePageLoadEvents()
  else window.addEventListener('dressx:amplitude-ready', firePageLoadEvents)

  var nativeOpen = XMLHttpRequest.prototype.open
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      this.__dxCartAdd = String(url || '').indexOf('/cart/add') !== -1
    } catch (e) {}
    return nativeOpen.apply(this, arguments)
  }
  var nativeSend = XMLHttpRequest.prototype.send
  XMLHttpRequest.prototype.send = function () {
    if (this.__dxCartAdd) {
      this.addEventListener('load', function () {
        try {
          trackCartAdd(JSON.parse(this.responseText))
        } catch (e) {}
      })
    }
    return nativeSend.apply(this, arguments)
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target
      if (!form || !form.action || form.action.indexOf('cart') === -1) return
      var submitter = e.submitter
      var isCheckout =
        submitter &&
        (submitter.name === 'checkout' ||
          submitter.getAttribute('name') === 'checkout')
      if (!isCheckout) return
      track('checkout_started', checkoutStartedProps())
    },
    true
  )

  if (template.indexOf('product') === 0) {
    function sizeProps(input, resolvedVariantId) {
      var p = params()
      var prod = metaProduct()
      var out = { try_on_completed: hasCompletedTryOn() }
      var variantId =
        (input && input.getAttribute('data-variant-id')) ||
        resolvedVariantId ||
        (p.variant_id != null ? p.variant_id : '') ||
        currentVariantId()
      if (variantId) out.id = variantId
      var cat = p.product_category || (prod && prod.type)
      if (cat) out.product_category = cat
      var brand = p.product_brand || (prod && prod.vendor)
      if (brand) out.product_brand = brand
      if (
        Array.isArray(p.product_collections) &&
        p.product_collections.length
      ) {
        out.product_collections = p.product_collections
      }
      return out
    }

    var lastSizeInput = null
    var lastSizeAt = 0
    function fireSizeSelected(input) {
      if (!input) return
      var now = Date.now()
      if (input === lastSizeInput && now - lastSizeAt < 400) return
      lastSizeInput = input
      lastSizeAt = now
      var before = currentVariantId()
      var attempts = 0
      ;(function settle() {
        var current = currentVariantId()
        if ((current && current !== before) || attempts >= 20) {
          track('size_selected', sizeProps(input, current || before))
          return
        }
        attempts += 1
        setTimeout(settle, 50)
      })()
    }

    function isSizeOptionInput(el) {
      if (!el || !el.getAttribute) return false
      if (el.hasAttribute('js-product-option-selector')) return true
      if (String(el.type || '').toLowerCase() !== 'radio') return false
      if (/^size/i.test(el.getAttribute('name') || '')) return true
      var fs = el.closest && el.closest('fieldset')
      var legend = fs && fs.querySelector('legend')
      return !!(legend && /^\s*size\b/i.test(legend.textContent || ''))
    }

    document.addEventListener(
      'change',
      function (e) {
        if (!isSizeOptionInput(e.target)) return
        fireSizeSelected(e.target)
      },
      true
    )

    document.addEventListener(
      'click',
      function (e) {
        var label =
          e.target && e.target.closest && e.target.closest('label[for]')
        if (!label) return
        var input = document.getElementById(label.getAttribute('for'))
        if (!isSizeOptionInput(input)) return
        fireSizeSelected(input)
      },
      true
    )
  }

  function fireSearchOpened(el) {
    var input =
      document.getElementById('header-search') ||
      document.querySelector('form[role="search"] input[type="search"]')
    var query = input && input.value ? input.value.trim() : ''
    var inDrawer = !!(
      el &&
      el.closest &&
      (el.closest('#SearchDrawer') || el.closest('[class*="drawer"]'))
    )
    track('search_opened', {
      signin: isSignedIn(),
      query: query,
      source: inDrawer ? 'drawer' : 'header',
    })
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target
      if (!t || !t.closest) return
      var trigger =
        t.closest('[js-search-drawer-open]') ||
        t.closest('[aria-controls^="header-search-dialog"]')
      if (trigger) fireSearchOpened(trigger)
    },
    true
  )

  function markLoginInitiated() {
    try {
      sessionStorage.setItem(LOGIN_FLAG_KEY, '1')
    } catch (err) {}
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target
      if (!form || !form.action) return
      if (String(form.action).indexOf('/account/login') === -1) return
      markLoginInitiated()
    },
    true
  )

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target && e.target.closest && e.target.closest('a[href]')
      if (!link) return
      var href = link.getAttribute('href') || ''
      if (
        href.indexOf('/account/login') !== -1 ||
        href.indexOf('customer_authentication/redirect') !== -1
      ) {
        markLoginInitiated()
      }
    },
    true
  )

  window.addEventListener('klaviyoForms', function (e) {
    var type = e && e.detail && e.detail.type
    if (type !== 'submit') return
    track('email_submitted', { description: 'user submitted email' })
  })

  function isShopifyEmailForm(form) {
    if (!form) return false
    var type = form.querySelector('input[name="form_type"]')
    if (type && type.value === 'customer') return true
    return !!(
      form.querySelector('input[name="contact[email]"]') ||
      form.querySelector('input[name="customer[email]"]')
    )
  }

  document.addEventListener(
    'submit',
    function (e) {
      if (!isShopifyEmailForm(e.target)) return
      try {
        sessionStorage.setItem(EMAIL_FLAG_KEY, '1')
      } catch (err) {}
    },
    true
  )
})()
